module.exports = __webpack_public_path__ + "img/scanning-animation.a3b324d7.gif";